import { createSelector } from 'reselect';
import { compose, get, has } from 'lodash/fp';
import { createScopedSelector, createAsyncMetaSelectors } from '@mews/framework';
import { gtZero } from '@mews/fp';
import { getOrEmptyArray } from '@mews-commander/utils';
import { moduleSelector } from './module';

const paginationSelector = createScopedSelector({ parentSelector: moduleSelector });
const getFromPagination = (propName: $TSFixMe) => compose(get(propName), paginationSelector);

const getTotalCount = getFromPagination('totalCount');

export const getPageSize = getFromPagination('pageSize');

export const getSelectedPage = getFromPagination('selectedPage');

export const getPages = getFromPagination('pages');

export const getMeta = getFromPagination('meta');

export const [isFetching, hasFailed] = createAsyncMetaSelectors(getMeta);

export const hasPage = createSelector(getPages, getSelectedPage, (pages, pageIndex) => has(pageIndex, pages));

export const getSelectedPageIds = createSelector(getPages, getSelectedPage, (pages, pageIndex) =>
    getOrEmptyArray(pageIndex, pages)
);

export const getTotalSize = createSelector(getTotalCount, getPageSize, (count, size) =>
    size === 0 ? 0 : Math.ceil(count / size)
);

export const hasEntities = compose(gtZero, getTotalCount);
